/**
 * @flow
 * @relayHash e5f86c094b4825fbe468ffc77014099f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ItemCategoryLabelQueryVariables = {|
  itemCategoryId: string
|};
export type ItemCategoryLabelQueryResponse = {|
  +itemCategory: {|
    +id: string,
    +name: string,
  |}
|};
export type ItemCategoryLabelQuery = {|
  variables: ItemCategoryLabelQueryVariables,
  response: ItemCategoryLabelQueryResponse,
|};
*/


/*
query ItemCategoryLabelQuery(
  $itemCategoryId: ID!
) {
  itemCategory(id: $itemCategoryId) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemCategoryId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "itemCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "itemCategoryId"
      }
    ],
    "concreteType": "ItemCategory",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ItemCategoryLabelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemCategoryLabelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ItemCategoryLabelQuery",
    "id": null,
    "text": "query ItemCategoryLabelQuery(\n  $itemCategoryId: ID!\n) {\n  itemCategory(id: $itemCategoryId) {\n    id\n    name\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d98f803283303e277831f6d6408a8c9';
module.exports = node;
